// export const IMAGE_SIZES = ['compact', 'medium', 'thumbnail', '']; // '' (which is default) means HUGE (largest one)

export const NORMAL_USER_TYPES = ['new', 'online', 'matches', 'featured']
export const SPECIAL_USER_TYPES = ['friends', 'visitors', 'nearMe']
export const USER_TYPES = [...NORMAL_USER_TYPES, ...SPECIAL_USER_TYPES]
export const USER_TYPES_MAP = USER_TYPES.reduce((a, b) => ({ ...a, [b]: b }), {})

// taken from http://www.regular-expressions.info/email.html
export const EMAIL_REGEX = /^[a-z0-9!#$%&'*+/=?^_‘{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_‘{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i

export const LEGAL_PAGE = /about|terms|privacy|cookie|faq|impressum|usc|contact(Us)?/

export const POLICY_IDS = {
  CHAT: 81,
  GALLERY: 95,
  XXX: 14,
  FLIRT: 108,
}

export const BANNERS = {
  HOME: 3,
  LOGOUT: 46,
}

export const REGISTRIES = {
  ZODIACS: 13,
  COUNTRIES: 74,
  SEXES: 89,
  ORIENTATIONS: 115,
  CRITERIA_ITEMS: 116,
  CRITERIA: 117,
  AGE: 143,
  // CRITERIA_GROUPS: 408,
  ADULT_RATINGS: 427,
  SUBSCRIPTION_SUSPEND_REASON: 520,
  FEEDBACK_REASON: 178,
}

export const MEMBERSHIPS = {
  VIP: 0,
  GOLD: 50,
}

export const NICHES = {
  DATING: 1,
  ADULT: 2,
  CASUAL: 5,
  FREE: 6,
  ADULT_RELOAD: 7,
  CASUAL_RESPONSIVE: 8,
  ADULT_REACT: 9,
}

export const MESSAGE_TYPES = {
  STANDARD_MAIL: 1,
  // INVITE_FRIENDS: 2,
  // WINK: 3,
  // PRIVATE_MEDIA_ITEM_REQUEST: 101,
  // PRIVATE_MEDIA_ITEM_ALLOWED: 102,
  // PRIVATE_MEDIA_ITEM_REJECTED: 103,
  // ADD_TO_FRIENDS_REQUEST: 106,
  // ASK_MORE_INFO_REQUEST: 111,
  // CHAT_REQUEST: 112,
  // SEND_PROFILE_TO_FRIENDS: 115,
  CARD: 149,
}

export const ACCOUNT_STATUS = {
  // REGISTERED: 1,
  // DELETED: 2,
  // CONFIRMED: 3,
  ACTIVATED: 4,
  // DEACTIVATED: 5, // not present in IConstants.java
  // INTEGRATED: 9,
}

// TODO: request isRegional in countries endpoint
export const REGIONAL_COUNTRIES = `
  9 13 14 20 21 26 29 32 37 42 44 48 49 50 52 53 57 58 60 63 68 71 76 79 85 89 90 92 94 98 99 100 102 103 104
  106 108 118 119 122 131 142 145 151 155 157 158 160 161 169 172 174 178 179 185 186 196 201 203 204 205
`
  .trim()
  .split(/\s+/)
  .map(e => +e)

export const NOTIFICATION_TYPES = ['WINK_SENT', 'PROFILE_VISIT', 'ADDED_TO_FAVORITES', 'FLIRT_REQUEST']

export const TITLES = {
  '/terms': 'sections/terms',
  '/about': 'sections/about',
  '/faq': 'sections/help',
  '/impressum': 'sections/impressumLink|clean',
  '/usc': 'sections/usc',
  '/privacy': 'sections/privacy',
  '/find-date': 'sections/findADate',
  '/cookie': 'sections/cookies',
  '/flirt': 'sections/flirt',
  '/myprofile': 'sections/myProfile',
  '/support/unsubscribe': 'sections/unsubscribe',
  '/mailbox': 'sections/mailbox',
  '/flirt/my': 'sections/flirtMy',
  '/flirt/withMe': 'sections/flirtWithMe',
  '/flirt/mutual': 'sections/flirtMutual',
}
